import React from 'react';
import '../styles/HowItWorks.css';
import { FaUserPlus, FaCheckCircle, FaShareAlt, FaGift } from 'react-icons/fa';

const HowItWorks = () => {
  const steps = [
    {
      icon: <FaCheckCircle />,
      title: 'Validation par l’admin',
      desc: 'L’administrateur valide votre compte suite à votre demande et vous envoie un lien d’activation.',
    },
    {
      icon: <FaShareAlt />,
      title: 'Partage du lien unique',
      desc: 'Generez un lien ou QR code unique à partager à votre communauté.',
    },
    {
      icon: <FaGift />,
      title: 'Réception des primes',
      desc: 'À chaque inscription validée, vous recevez une prime affichée dans votre espace staut solde.',
    },
  ];

  return (
    <section className="how-section" id="how">
      <h2 className="how-title">Comment ça marche ?</h2>
      <div className="how-grid">
        {steps.map((step, index) => (
          <div className="how-card" key={index}>
            <div className="step-number">{index + 1}</div>
            <div className="how-icon">{step.icon}</div>
            <h3>{step.title}</h3>
            <p>{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
